<template>
  <div>
    <!-- 提货密码 -->
    <modalDefault :showModal="showModal" @close="close()" :modalText="persons == 2 ? '双人对战' : '三人对战'" :showCancel="false"
      :showConfirm="false">
      <template #dialogContent>
        <div class="num-dialog">
          <div class="num-dialog-wrap">
            <div class="num-dialog-content">
              <div class="room-info-content">
                <div class="room-info">
                  <div class="info-inner">
                    <div class="box-num">
                      箱子件数
                      <span class="text">{{ boxNumber }}</span>
                    </div>
                    <div class="total-price">
                      箱子总价
                      <span class="text">{{ boxAmount * number }}</span>
                    </div>
                  </div>
                  <!-- <div class="info-btm-bg"></div> -->
                </div>
                <div class="num-show-box">
                  <text>
                    房间数量
                    <span class="buy-num">{{ number }}</span>
                  </text>
                </div>
              </div>
            </div>

            <div class="btn-box flex-center">
              <div class="cm-btn skins__btn" style="color: #fff" @click="doCreate">
                确定
              </div>
            </div>
          </div>
        </div>
      </template>
    </modalDefault>
  </div>
</template>
<script>
import modalDefault from "@/components/common/modalDefault.vue";
export default {
  name: "modalRealName",
  components: {
    modalDefault,
  },
  data() {
    return {
      number: 1,
      showNoBalance: false,
      config: {
        battle_create_home_number: 0,
      },
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    persons: {
      type: Number,
      default: 2,
    },
    boxNumber: {
      type: Number,
      default: 0,
    },
    boxAmount: {
      type: String,
      default: 0,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    doCreate() {
      this.$emit("doCreate");
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.common-small-dialog-content {
  height: 200px;
}

.num-dialog {
  position: relative;
  font-size: 3.33 * 4.2px;
  padding: 0 0 8.8 * 4.2px;
  width: 100%;
}

.num-dialog-wrap .num-dialog-content .box-info-content {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.num-dialog-wrap .num-dialog-content .box-info-content .box-info-wrap {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 6.67 * 4.2px;
}

.num-dialog-wrap .num-dialog-content .box-info-content .box-info-wrap .box-img {
  width: 18.13 * 4.2px;
  height: 18.13 * 4.2px;
  margin-right: 3.2 * 4.2px;
}

.num-dialog-wrap .num-dialog-content .box-info-content .box-info-wrap .box-img img {
  width: 100%;
  height: 100%;
  -o-object-fit: scale-down;
  object-fit: scale-down;
}

.num-dialog-wrap .num-dialog-content .box-info-content .box-info-wrap .box-base-info .box-name {
  color: #9bb8ec;
}

.num-dialog-wrap .num-dialog-content .box-info-content .box-info-wrap .box-base-info .box-price {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  color: #52f9ff;
  margin: 0.67 * 4.2px 0 0;
}

.num-dialog-wrap .num-dialog-content .box-info-content .box-info-wrap .box-base-info .box-price .coin {
  width: 3.87 * 4.2px;
  height: 3.6 * 4.2px;
}

.num-dialog-wrap .num-dialog-content .box-info-content .box-info-wrap .num-show-box {
  color: #9bb8ec;
  margin: 2.67 * 4.2px 0 0;
}

.num-dialog-wrap .num-dialog-content .box-info-content .box-info-wrap .num-show-box .buy-num {
  color: #fff;
}

.num-dialog-wrap .num-dialog-content .room-info-content {
  color: #fff;
  padding: 7 * 4.2px 4 * 4.2px 0;

}

.room-info {
  background-color: #032E69;
  padding: 3vw;
  border-radius: 6px;
}

.num-dialog-wrap .num-dialog-content .room-info-content .room-info .info-inner {
  height: 4 * 4.2px;
}

.num-dialog-wrap .num-dialog-content .room-info-content .room-info .info-inner .box-num {
  float: left;
}

.num-dialog-wrap .num-dialog-content .room-info-content .room-info .info-inner .box-num .text {
  color: #52f9ff;
  padding-left: 2.67 * 4.2px;
}

.num-dialog-wrap .num-dialog-content .room-info-content .room-info .info-inner .total-price {
  float: right;
}

.num-dialog-wrap .num-dialog-content .room-info-content .room-info .info-inner .total-price .text {
  color: #52f9ff;
  padding-left: 2.67 * 4.2px;
}

.num-dialog-wrap .num-dialog-content .room-info-content .room-info .info-btm-bg {
  width: 72.8 * 4.2px;
  height: 2.67 * 4.2px;
  margin: 2.67 * 4.2px 0 0 -4.27 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/create_bg6.png");
}

.num-dialog-wrap .num-dialog-content .room-info-content .num-show-box {
  color: #9bb8ec;
  text-align: center;
  margin: 8 * 4.2px 0 0;
}

.num-dialog-wrap .num-dialog-content .room-info-content .num-show-box .buy-num {
  color: #fff;
  padding: 0 0 0 2.67 * 4.2px;
}

.num-dialog-wrap .slider-box {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-size: 55.2 * 4.2px 3.47 * 4.2px;
  background-position: center center;
  margin: 2.67 * 4.2px 0 0;
  background-repeat: no-repeat;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZ4AAAAaCAMAAACw9MpHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAC3UExURV6C3F2C216A3YCA/16C3F+E2l6C3AAAAF+C3FVxxl6C3*4.2pxIzF2C21+D3V2A3F6C3F6C3AD//16C3F6C3F2D3VuA7V6C3FyB3V+C3ICAgFiA2F6C3F6C20mS216E3l6D212C3F6C3DpJbjlIbTA9XDVDZl6C3DpIbTlIbDVDZThHazRBYzlHazZEZjhGaj1RgDJAYDdFaTdGaVd3yDVCZDZFajZFZzNAYTA8XC46WUtmqTRBYjA8WllFpQIAAAAidFJOU/b7JgTrPrEAkQnbD/NxFvfGAa3yUg71W8wCGvh6Bzae4PyZXKTNAAABK0lEQVRo3u2aVxrCMAyDw6aUvfdqazopUDbc/1xAWT2CHvQ/5ADWF0exrAoxnWZXERi6zc5bFxWfjXbrejmbBILz5dpqNxLyVOtieo5FIHA8U+rVvzyZSi0MXNsgENhuENYqmZ886ZJ469WSgLBae1JKf+XRiqnD0WZVcLCPh1RR+8iTy8re5eVBuj7uXrK5tzx6XjZbgzVBwthuJK+/5Bn0ypHjsyJY+E5U7g2e8gz7ctqxtaG1t91J+sOCmoxHYUBfgOcOgnA0nqjpXG401Yjm+ibzqZot7hZfHsTXx7ovZpQHWx42N+jmRmsAbQ1orKGNNb+l2N9SDnUA+Q91OBIFbG2JkSgDBTxfkAwUGMfBmepkHMcwGzvM5ioI9CoIF6mwF6m4hgi6hvgAnlIvtK*4.2pxBEwAAAAASUVORK5CYII=);
}

.num-dialog-wrap .slider-box .opt-btn {
  width: 6 * 4.2px;
  height: 8 * 4.2px;
}

.num-dialog-wrap .slider-box .reduce-btn {
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,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*4.2pxp4ur2bTpNHRxECe2a8nsL9iLm/LbfgwVOljzfLjlhzb3hSvso4ASHd1WSmH1YVeBTNt1i31wUDmfnJDQ5wlXr+HL8cUh1XE6+7sEbPzU2SbPa0YOfnxNyxX2qqdql5w30WfV0KUETyVh3+yRXOzYtZsaOsPIK+z2zRFcjL+8x0ANnXjEhSfpGuH8AU13Ax+Pntfj6j9+n8h28QY+TD0vU687d2/t+x9IvzoZVGoUFQAAAABJRU5ErkJggg==);
}

.num-dialog-wrap .slider-box .reduce-btn.disabled {
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(100%);
}

.num-dialog-wrap .slider-box .add-btn {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAA8CAMAAADFTsOWAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAMAUExURQAAADM4/z0//0A8/0BF/1VE/0Q4/w0Z/wAJ/zQ8/0M9/z+1/kA9/zk3/0I8/0Iv/0Ct/zxF/0I//0BB/z49/zw6/0A//zpe/0I//0M+/0NA/wAK/0A3/0M+/0M//0M//0Q//zIy/0M+/0I//0I+/0I+/0I+/0M//0M+/0M7/0I+/0E//0I//0M//0M//0M+/0M//0I//0M//zRW/zpk/0Fq/0I+/0I9/0M//0M+/0Ce/ji+/ze9/zdX/0KG/0I+/0I9/0M+/0M//0Q+/0Jq/z5s/zhd/0nV/0M+/0E7/0Q//0I//0I//0FB/0NA/zRX/y9P/zpb/0Bc/0Kh/0K1/0I+/0M//0I+/0E9/z9B/0E//0I//0NM/0NA/0JW/zm8/zpb/zda/zdO/0Bg/0Bd/z9m/zth/zpr/zJQ/zFS/z5u/0DM/0PK/z/O/UM//0M//0M+/0E//0I+/0GN/kJF/0CW/je6/zZZ/0Ct/j9f/z9c/0F4/z92/zi8/z52/j9b/ztd/z54/0BZ/zZt/0BY/z9d/z9e/z9c/z7L/UDN/z/J/UM//0I9/0E9/0E9/z9D/0GC/kFD/zxI/z93/T1F/0CH/kB2/z55/0Bd/z9b/0Bb/z5z/0Bn/0BD/z5c/z9b/z9u/0RB/0CT/kBt/z9z/0Bm/z/Q/T/M/j/S/T5U/z+M/j7T/zzb/z/O/j/Q/kZB/0Q//0Ck/kJg/0Fs/0NL/zi3/zpG/zdK/ztH/zhG/zi6/0GU/jBR/z91/ylY/y1z/yxn/0CO/ytr/yxu/0Gl/kCG/0GE/0CA/T9e/z9V/z+e/j+n/j+w/j/Y/j5T/z/S/j+D/j97/j/P/T/W/D/H/T/B/T/H/UCZ/j+0/kGB/kFy/z91/0Q//z/W/UC6/UGL/kGv/T/C/UCY/0C7/kGH/0C8/kCQ/T7b/D/c/UCa/0Ni/j++/T9g/z9g/z/Y/T+7/T/M/UQ//0M//zjA/0NG/0ND/0NK/0JY/0Ji/0RB/0NO/0Jw/kF3/kNT/0Jm/kF4/76Z2UcAAAD/dFJOUwAFCBMEAwsBAgYn2hkJFgccGCQPEQwgCzBXRAMOs6pGLRF9aTtjj5uKHnJgeJPPuMDE7BsMGkozo8j8/PY3Gz4rbss1EQkTA0AbmIKfutMfQwc+GxtN9H82ZVGF21ne+ZgkYGFGMhasKy4nDAeG+fxdVK371vv5qft7ufCz7oWnhR6vVItoLVBeE0DhUrw4p/2ztp6U9j5YWZ+SdL1twHWQ7Njb3tedtG7C2iocvzLu3P3m7Mz3fI6xSvHpVMA+iW0pa07xbzmVs4La2tq1b1Ta2sxGp9*4.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);
  background-size: 100% 100%;
}

.num-dialog-wrap .slider-box .add-btn.disabled {
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(100%);
}

.num-dialog-wrap .slider-box .opt-pregress-box {
  width: 48 * 4.2px;
  height: 3.47 * 4.2px;
  margin: 0 2.67 * 4.2px;
}

.num-dialog-wrap .slider-box .opt-pregress-box .van-slider {
  width: 48 * 4.2px;
  height: 3.47 * 4.2px;
  -webkit-border-radius: 0;
  border-radius: 0;
  margin-top: 0px;
  background-color: transparent;
  background-size: 100% 100%;
}

.num-dialog-wrap .slider-box .opt-pregress-box .van-slider::before {
  display: none;
}

.num-dialog-wrap .slider-box .opt-pregress-box .van-slider .van-slider__bar {
  width: 48 * 4.2px;
  height: 3.47 * 4.2px;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
}

.num-dialog-wrap .slider-box .opt-pregress-box .drag {
  width: 2.27 * 4.2px;
  height: 6.93 * 4.2px;
  margin: 1.33 * 4.2px 0 0 0;
}

.num-dialog-wrap .btn-box .cm-btn {
  width: 38 * 4.2px;
  height: 8.13 * 4.2px;
  line-height: 8.13 * 4.2px;
  text-align: center;
  margin: 0px 0 0;
  background-size: 100% 100%;
  background-image: url("../../assets/knapsack/9.png");
  font-size: 14px;
  color: #FFFFFF;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  // background-image: url("../../assets/images/btn_bg3.png");
}
</style>